<script setup lang="ts"></script>

<template>
  <icon name="mdi:wand" />
</template>

<style scoped></style>
